module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"exchangeMessage":"The currencies of the sender\u0027s and recipient\u0027s accounts are different. The {src} to {dst} exchange will be made at the current rate."},"ru":{"exchangeMessage":"Валюты счетов отправителя и получателя разные. Обмен {src} на {dst} будет произведен по текущему курсу."}}')
  delete Component.options._Ctor
}
